var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListado(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 537.04 537.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current-color"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 67.08,
    y: 336.54,
    width: 44.09,
    height: 32.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 67.08,
    y: 420.54,
    width: 44.09,
    height: 32.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 67.08,
    y: 252.54,
    width: 44.09,
    height: 32.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 67.08,
    y: 168.54,
    width: 44.09,
    height: 32.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 67.08,
    y: 84.54,
    width: 44.09,
    height: 32.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 435.26,
    y: 167.57,
    width: 34.39,
    height: 34.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 435.26,
    y: 82.57,
    width: 34.39,
    height: 34.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 435.26,
    y: 250.57,
    width: 34.39,
    height: 34.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 435.26,
    y: 336.57,
    width: 34.39,
    height: 34.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 386.26,
    y: 336.57,
    width: 34.39,
    height: 34.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 386.26,
    y: 82.57,
    width: 34.39,
    height: 34.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 435.26,
    y: 418.57,
    width: 34.39,
    height: 34.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 156.04,
    y: 337,
    width: 180.52,
    height: 32.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 156.04,
    y: 419,
    width: 180.52,
    height: 32.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 156.04,
    y: 253,
    width: 180.52,
    height: 32.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 156.04,
    y: 168,
    width: 180.52,
    height: 32.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 156.04,
    y: 84,
    width: 180.52,
    height: 32.87
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListado);
export default __webpack_public_path__ + "static/media/listado.f12e9055dedb83c7f7de13164f15cf22.svg";
export { ForwardRef as ReactComponent };